import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { SubjectFormValues } from "src/models/Subject.model";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";

type Props = {
  formikProps: FormikProps<SubjectFormValues>;
  onClose: () => void;
  formType: "ADD" | "EDIT";
};

const SubjectForm = ({ formikProps, onClose, formType }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
          {formType === "ADD" ? "Add Subject" : "Update Subject"}{" "}
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <ATMTextField
            name="subjectName"
            value={values.subjectName}
            required
            onChange={(e) => {
              setFieldValue("subjectName", e.target.value);
            }}
            label="Subject Name"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMTextField
            name="subjectCode"
            value={values.subjectCode}
            required
            onChange={(e) => {
              setFieldValue("subjectCode", e.target.value);
            }}
            label="Subject Code"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMTextField
            name="shortName"
            value={values.shortName}
            onChange={(e) => {
              setFieldValue("shortName", e.target.value);
            }}
            label="Short Name"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMTextField
            name="metaKeywords"
            value={values.metaKeywords}
            onChange={(e) => {
              setFieldValue("metaKeywords", e.target.value);
            }}
            label="Meta Keywords"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMTextArea
            name="metaDescription"
            value={values.metaDescription}
            onChange={(value) => {
              setFieldValue("metaDescription", value);
            }}
            label="Meta Description"
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default SubjectForm;
